import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from '../../SuperUser/Report/redux/actions';
import { graphContainer } from './graphContainers';
import { ColorPalette } from '../DashboardColorPalettes';
import GenericCategoryGraph, { chartTypeEnum } from '../../../components/Graphs/GenericCategoryGraph';
import { genIntervalName } from './MetricTrendAllIntervals';

export const MetricsForTrendPlot = {
  activated_enrollments: {
    id: 'activated_enrollments',
    label: 'Activated Patients',
  },
  enrolled_enrollments: {
    id: 'enrolled_enrollments',
    label: 'Enrolled Patients',
  },
  registered_enrollments: {
    id: 'registered_enrollments',
    label: 'Registered Patients',
  },
  disenrolled_enrollments: {
    id: 'disenrolled_enrollments',
    label: 'Disenrolled Patients',
  },
  active_kits: {
    id: 'active_kits',
    label: 'Active Kits',
  },
  total_no_of_kits: {
    id: 'total_no_of_kits',
    label: 'Total Kits',
  },
};

export const getMetricTrendMetadata = metric => {
  return {
    id: `MetricTrendWidget_${metric}`,
    name: `${MetricsForTrendPlot[metric]?.label} Trend`,
    permission: '',
    defProps: { i: `MetricTrendWidget_${metric}`, w: 4, h: 4, minW: 2, minH: 4 },
    configuration: {
      chartType: {
        type: 'select',
        name: 'chartType',
        label: 'Chart Type',
        defaultValue: chartTypeEnum.bar,
        options: [
          { label: 'Bar chart', value: chartTypeEnum.bar },
          { label: 'Area chart', value: chartTypeEnum.area },
          { label: 'Line chart', value: chartTypeEnum.line },
          { label: 'Horizontal bar chart', value: chartTypeEnum.horizontalBar },
          { label: 'Grid', value: "grid" },
        ],
        canBeSetByDashboard: false,
      },
      plotInterval: {
        type: 'select',
        name: 'plotInterval',
        label: 'Plot Interval',
        defaultValue: 'months',
        options: [
          { label: 'Daily', value: 'days' },
          { label: 'Weekly', value: 'weeks' },
          { label: 'Monthly', value: 'months' },
        ],
        canBeSetByDashboard: false,
      },
      rollingPeriod: {
        type: 'select',
        name: 'rollingPeriod',
        label: 'Rolling Period (days / weeks / months)',
        defaultValue: 4,
        options: [
          { label: '2', value: 2 },
          { label: '3', value: 3 },
          { label: '4', value: 4 },
          { label: '5', value: 5 },
          { label: '6', value: 6 },
        ],
        canBeSetByDashboard: false,
      },
    }
  }
};

export const getActiveKitsCount = daysWithReadings => {
  if (!daysWithReadings) return 0;
  return Object.keys(daysWithReadings).filter(k => k > 0).reduce((acc, day) => {
    return acc + (daysWithReadings[day] || 0);
  }, 0);
};

function MetricTrend(props) {
  const { rollingPeriod, plotInterval, metric, data } = props;
  const { colorPalette, graphType } = props;

  const dataSeries = [{
    name: plotInterval,
    // color: colorPalette?.interpolate(0.73),
    selector: item => item.count,
  }];
  
  const graphData = Array.from({ length: rollingPeriod }, (_, i) => ({
    count: metric === "active_kits" ? getActiveKitsCount(data?.[plotInterval]?.[-i]?.days_with_vitals) : data?.[plotInterval]?.[-i]?.[metric] || 0,
    period: genIntervalName(plotInterval, i),
  }));

  const grid = (
    <div className="box2colsWithVl vncols" style={{ gridTemplateColumns: `repeat(${rollingPeriod}, 1fr)` }}>
      {graphData &&
        graphData.map(v => (
          <div className="box2colsWithVl-box" key={v.period}>
            <div className="box2colsWithVl-valueBox black">
              {v.count}
            </div>
            <div className="box2colsWithVl-labelBox">
              {v.period}
            </div>
          </div>
        ))}
    </div>
  );

  const graph = (
    <GenericCategoryGraph
      graphData={graphData}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={graphType === chartTypeEnum.horizontalBar ? 100 : 40}
      yAxisUnit=""
      tooltipTitle={`Number of ${MetricsForTrendPlot[metric]?.label}`}
      dataSeries={dataSeries}
      categorySelector={item => item.period}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
    />
  );
  return graphContainer(graphType === "grid" ? grid : graph, `Number of ${MetricsForTrendPlot[metric]?.label}`);
}

MetricTrend.propTypes = {
  getPatientsStatistics: PropTypes.func,
  onClick: PropTypes.func,
  colorPalette: PropTypes.any,
  refreshTimestamp: PropTypes.any,
  graphType: PropTypes.string,
  dragging: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    colorPalette:
      ColorPalette[state.dashboardState.configuration?.allDashboards?.colorPalette] || Object.values(ColorPalette)[0],
  };
};


const mapDispatchToProps = dispatch => ({
  getEnrollmentsMetrics: pageRequest => dispatch(actions.getEnrollmentsMetrics(pageRequest)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MetricTrend);
